// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2TlVJ","content":"GlobalSearch_content__2gOry"};